import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Store} from '@ngrx/store';
import {AppState} from '../store';
import {Observable} from 'rxjs';
import {getSubscriptionContent} from '../store/content.actions';
import {createContentResolver} from './create-content-resolver';
import {LoadingService} from '../shared/services/loading.service';


@Injectable({
  providedIn: 'root'
})
export class SubscriptionContentResolver  {


  constructor(
    private store:Store<AppState>,
    private loading: LoadingService) {

  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {

    const loadContent$ = createContentResolver(this.store, "subscription", getSubscriptionContent);

    return this.loading.showLoaderUntilCompleted(loadContent$);
  }


}
